import { supabase } from '../lib/supabase';
import { publicRedirect } from '../lib/canonical';
import { getTurnstileToken, captchaOptions, turnstileEnabled } from '../lib/turnstile';

export function renderSignin(container: HTMLElement): void {
  container.innerHTML = `
    <main class="container narrow">
      <h1>Sign in to edit your profile</h1>
      <p class="lead">Enter the email address where your invite was sent. We'll email you a one-time sign-in link.</p>
      <form id="signin-form">
        <label for="email">Email</label>
        <input type="email" id="email" name="email" required autocomplete="email" />
<div class="ts-mount" id="ts-signin"></div>
        <button type="submit">Send me a sign-in link</button>
      </form>
      <p id="signin-status" class="status" aria-live="polite"></p>
      <p class="muted small">
        No account yet? <a href="#/apply">Get listed on Curate</a>.
      </p>
    </main>
  `;

  const form = container.querySelector<HTMLFormElement>('#signin-form');
  const status = container.querySelector<HTMLElement>('#signin-status');
  if (!form || !status) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    const email = String(fd.get('email') ?? '').trim().toLowerCase();
    if (!email) return;

    status.textContent = 'Sending…';
    status.className = 'status';

    // Turnstile is inert unless VITE_TURNSTILE_SITE_KEY is set; a failed or
    // unavailable challenge yields null and the request proceeds. The
    // server-side caps are the control that always holds (WP5).
    const tsMount = container.querySelector<HTMLElement>('#ts-signin');
    const tsToken = tsMount ? await getTurnstileToken(tsMount) : null;
    const { error } = await supabase.auth.signInWithOtp({
      email,
      // Note: Supabase's allowlist matcher strips URL fragments from incoming
      // redirect_to requests before comparison, so we cannot send `#/edit` here
      // and expect it to match an allowlist entry with `#/edit` in it. We send
      // the origin URL only; main.ts's onAuthStateChange listener routes the
      // user to #/edit once SIGNED_IN fires post-callback.
      options: {
        emailRedirectTo: publicRedirect(),
        shouldCreateUser: false,
        ...captchaOptions(tsToken),
      },
    });

    if (error) {
      status.textContent = `Sorry — ${error.message}. Try again or contact john@ebikesflorence.com.`;
      status.className = 'status status-error';
      return;
    }

    status.textContent = `Check your inbox for ${email}. The link expires in 60 minutes.`;
    status.className = 'status status-success';
    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
  });
}
